import { createBrowserRouter, Navigate, Outlet, ScrollRestoration, type RouteObject } from 'react-router';
import { AppShell, RequireAuth, RouteError } from './AppShell';
import { publicRoutes as authRoutes } from '../features/auth/routes';
import { publicRoutes as landingRoutes } from '../features/landing/routes';
import { publicRoutes as legalRoutes } from '../features/legal/routes';
import * as dashboard from '../features/dashboard/routes';
import * as pos from '../features/pos/routes';
import * as orders from '../features/orders/routes';
import * as products from '../features/products/routes';
import * as catalog from '../features/catalog/routes';
import * as finance from '../features/finance/routes';
import * as customers from '../features/customers/routes';
import * as stats from '../features/stats/routes';
import * as team from '../features/team/routes';
import * as settings from '../features/settings/routes';
import * as intelligence from '../features/intelligence/routes';
import * as stock from '../features/stock/routes';

const features = [dashboard, pos, orders, products, catalog, finance, customers, stats, team, settings, intelligence, stock];

/**
 * Rolagem: tela nova abre no topo; "voltar" devolve a posição anterior da lista.
 * A chave é o caminho: trocar filtro/aba (?q=, ?aba=) na mesma tela não pula para o topo.
 */
function RootLayout() {
  return (
    <>
      <ScrollRestoration getKey={(location) => location.pathname} />
      <Outlet />
    </>
  );
}

/**
 * Vitrine do design system (/design): só existe no desenvolvimento. Em produção o Vite troca
 * import.meta.env.DEV por false e o import some do bundle.
 */
const devRoutes: RouteObject[] = import.meta.env.DEV
  ? [
      {
        path: 'design',
        lazy: async () => ({ Component: (await import('../features/design/DesignPage')).default }),
      },
    ]
  : [];

const routes: RouteObject[] = [
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <RouteError />,
    children: [
      ...landingRoutes,
      ...authRoutes,
      ...legalRoutes,
      ...devRoutes,
      {
        element: <RequireAuth />,
        children: [
          ...features.flatMap((f) => f.fullscreenRoutes),
          {
            element: <AppShell />,
            errorElement: <RouteError />,
            children: features.flatMap((f) => f.routes),
          },
        ],
      },
      { path: '*', element: <Navigate to="/inicio" replace /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
